import { createAsyncThunk } from "@reduxjs/toolkit";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";

export interface PedingTask {
  id?: number;
  pedingTaskName: string;
  state: string;
  status: boolean;
  createBy?: string;
  updatedBy?: string;
  createDate?: string;
  updateDate?: string;
}
export interface PaginatedResponse<T> {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const fetchpedingTasks = createAsyncThunk(
  "pedingTask/fetchpedingTasks",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      if (filters && filters.length > 0) {
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              if (typeof filterValue === "object" && filterValue !== null) {
                // Handle cases like { from_date: ..., to_date: ... }
                Object.entries(filterValue).forEach(([key, value]) => {
                  if (value !== undefined && value !== null && value !== "") {
                    params.append(key, String(value));
                  }
                });
              } else {
                // Handle primitive values (string, number)
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }

      const response: any = await Axios.get(
        `/pedingTask/?${params.toString()}`
      );
      // const response: any = await Axios.get(`/district/`, {
      //   params: {
      //     page,
      //     page_size: pageSize,
      //     search: search || undefined,
      //     filters: filters ? JSON.stringify(filters) : undefined,
      //   },
      // });

      // response.data;
      return {
        data: response.data.data || [],
        rowCount: response.data.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetchpedingTasks error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch districts");
    }
  }
);

export const fetchOnlyAllpedingTasks = createAsyncThunk(
  "",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get("/pedingTask");
      return response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch pedingTask by ID"
      );
    }
  }
);

export const fetchpedingTaskById = createAsyncThunk(
  "pedingTask/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/pedingTask/${id}/get/`);
      return response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch pedingTask by ID"
      );
    }
  }
);

export const fetchpedingTaskByDropDown = createAsyncThunk(
  "pedingTask/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/pedingTask/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch pedingTask list"
      );
    }
  }
);

export const updatepedingTask = createAsyncThunk(
  "pedingTask/updatepedingTask",
  async ({ id, pedingTaskData }: { id: string; pedingTaskData: any }) => {
    const response: any = await Axios.put(
      `/pedingTask/${id}/update/`,
      pedingTaskData
    );
    return response;
  }
);

export const addpedingTask = createAsyncThunk(
  "pedingTask/addpedingTask",
  async (pedingTaskData: any) => {
    const response = await Axios.post(`/pedingTask/create/`, pedingTaskData);
    return response.data;
  }
);

export const exportpedingTaskCSV = async () => {
  const response = await Axios.get("/pedingTask/?export=csv", {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "pedingTask.csv",
  };
};
